import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { AgCharts } from "ag-charts-react";

import { eSalaryGet } from "../../api";
import { customChartThemes } from "../../common/grid";
import { IconMoney } from "../../common/icons";
import { LoadingContainer } from "../../common/loaders/loadingcontainer";
import { capitalizeFirstLetter, jsError, localized } from "../../common/utils";


export function Expenses() {
  const { t } = useTranslation();

  const localizedMonth = new Intl.DateTimeFormat(localized.resolvedLanguage, { month: "long" });
  const monthName = idx => capitalizeFirstLetter(localizedMonth.format(new Date(Date.UTC(2000, idx, 1, 0, 0, 0))));
  const [data, setData] = useState();

  const { chartTheme } = customChartThemes;

  useEffect(() => {
    (async () => {
      try {
        const res = await eSalaryGet("salarycosts");
        const salaryCosts = res.data.payrollstatus[0];
        salaryCosts.salaryData = [
          { salary: salaryCosts["costsq:salaryjanuary"], title: monthName(0), },
          { salary: salaryCosts["costsq:salaryfebruary"], title: monthName(1), },
          { salary: salaryCosts["costsq:salarymarch"], title: monthName(2), },
          { salary: salaryCosts["costsq:salaryapril"], title: monthName(3), },
          { salary: salaryCosts["costsq:salarymay"], title: monthName(4), },
          { salary: salaryCosts["costsq:salaryjune"], title: monthName(5), },
          { salary: salaryCosts["costsq:salaryjuly"], title: monthName(6), },
          { salary: salaryCosts["costsq:salaryaugust"], title: monthName(7), },
          { salary: salaryCosts["costsq:salaryseptember"], title: monthName(8), },
          { salary: salaryCosts["costsq:salaryoctober"], title: monthName(9), },
          { salary: salaryCosts["costsq:salarynovember"], title: monthName(10), },
          { salary: salaryCosts["costsq:salarydecember"], title: monthName(11), },
        ];
        setData(salaryCosts);
      } catch (err) {
        jsError(err);
      }
    })();
  }, []);

  /** @type {import("ag-grid-enterprise").AgChartOptions} */
  const options = {
    data: data?.salaryData, // array of yearly salary data
    series: [
      {
        type: "line",
        xKey: "title",
        yKey: "salary",
        xName: t("ExperienceYears", "Kokemusvuodet"),
        tooltip: {
          renderer: function ({ datum, xKey, yKey }) {
            return {
              title: `${datum[xKey]}: ${localized.currencyFormat.format(datum[yKey])}`,
              data: [],
            };
          },
        },
      },
    ],
    legend: {
      enabled: false,
    },
    theme: { ...chartTheme, palette: {...chartTheme.palette, fills: ["#B7A0E0"]} },
    locale: localized.agChartsLocale,
  };

  return data
    ? <>
      <h4 style={{color: "var(--heeros-blue)"}}>{t("Expenses", "Kulut")}</h4>

      <div><AgCharts options={options} /></div>

      <b>{t("WageCosts", "Palkat")}</b>
      <Row className="gap-2">

        <Col><Row className="align-items-center">
          <Col className="flex-grow-0"><IconMoney /></Col>
          <Col>
            <div>{t("CurrentYear", "Kuluva vuosi")}</div>
            <b>{localized.numberFormat.format( data["costsq:salarycurrentyear"] )} €</b>
          </Col>
        </Row></Col>

        <Col><Row className="align-items-center">
          <Col className="flex-grow-0"><IconMoney bgColor="#80DBF1" fgColor="#406D78" /></Col>
          <Col>
            <div>{t("PreviousYear", "Viime vuosi")}</div>
            <b>{localized.numberFormat.format( data["costsq:salarypreviousyear"] )} €</b>
          </Col>
        </Row></Col>

        <Col><Row className="align-items-center">
          <Col className="flex-grow-0"><IconMoney bgColor="#8FE3D0" fgColor="#477168" /></Col>
          <Col>
            <div>{t("YearToYear", "Vuodesta vuoteen")}</div>
            <b>{localized.numberFormat.format( data["costsq:salaryyeartoyear"] )} €</b>
          </Col>
        </Row></Col>

      </Row>

    </>
    : <LoadingContainer />;
}
